import { render } from "./KunstKulturKategorie.vue?vue&type=template&id=31a5697a"
import script from "./KunstKulturKategorie.vue?vue&type=script&lang=js"
export * from "./KunstKulturKategorie.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__